//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.SpinePlaneBuilderList.js";
import "../no/ObjectList.js";
let d=[[[0,"ArcSegmentsType",1,0],[0,"Associative",1,0],[0,"Closed",1,0],[0,"ReverseStartDirection",1,0],[0,"StartPoint",1,"Point",0],[1,"ThroughPlanesList",0,"GeometricUtilities.SpinePlaneBuilderList",0]],[[[],"Evaluate",{},0,0]],[]];
SPLM.Features.SpineCurveBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SpineCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SpineCurveBuilder.ArcSegmentsTypes = Object.freeze({
    "Simple" : "Simple", "Smooth" : "Smooth"});

export default SPLM;